

Vue.component('chat-loading', {
	props: ["options","labellang"],
	template:
	'<div id="loading" v-if="isActive" class="row text-center no-gutters">'+
			'<div class="text-center loader-custom"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>'+
			'<div class="text-center margin-custom">'+
			'<p class="text-info offset-top-10">{{ msgLoading }}<a href="https://www.crif.it/privacy-policy/" target="_blank" style="color: blue"> {{ link }}</a></p>'+
			'<p class="text-info offset-top-10">{{ msgLoading2 }}</p>'+
	'</div>',
data:function(){
	return {
		isActive:true,
		msgLoading:"Loading...",
		msgLoading2:" del sito Crif.it",
		iconLoader:'../img/loader.svg',
		link:"Privacy Policy",
	}
},
mounted: function() {
	var that = this;

	this.$parent.$on('onShowLoading', function (val) {
		that.contentShow(val);
	})
	this.$parent.$on('onMsgLoading', function (msg) {
		that.changeMsg(msg);
	})

	this.setLabel();

},
methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		changeMsg:function(msg){
			this.msgLoading = msg;
			if(msg==null||msg==''||msg==""){
				this.link='';
				msgLoading2 = '';
			}
		},
		svgOnError:function(){

		},
		setLabel:function(){
				this.msgLoading = this.labellang.loading;
		}

},
})
